/**
 * @generated SignedSource<<9f568f9e0c6da06e6428c54183c8f92b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type BoardInvalidDropTargetMessage_old_column$data = {
  readonly __typename: string;
  readonly " $fragmentType": "BoardInvalidDropTargetMessage_old_column";
};
export type BoardInvalidDropTargetMessage_old_column$key = {
  readonly " $data"?: BoardInvalidDropTargetMessage_old_column$data;
  readonly " $fragmentSpreads": FragmentRefs<"BoardInvalidDropTargetMessage_old_column">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "BoardInvalidDropTargetMessage_old_column",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__typename"
    }
  ],
  "type": "JiraBoardViewColumn",
  "abstractKey": "__isJiraBoardViewColumn"
};

(node as any).hash = "d8e6d04af7414c5f8f863b2c6f386a96";

export default node;
